import { useTransferOffers } from '@hooks/queries/registry/transferInstruction/useTransferOffers';
import { useParties } from '../../contexts/PartiesContext';

export const useInboundTransferOffers = () => {
  const { party } = useParties();

  const transferOffers = useTransferOffers();
  const data = transferOffers.data?.map((r) => {
    const { transfer } = r.payload;
    const payload = {
      sender: transfer.sender,
      receiver: transfer.receiver,
    };
    return {
      payload,
    };
  });
  const transfers2Step = (data || []).filter((t) => t.payload?.receiver === party);
  return transfers2Step;
};
